import { embedDashboard } from '@superset-ui/embedded-sdk';
import { fetch_land_court_superset_dashboard } from '@/services/land_court_service';
import alert_mixin from '@/utils/mixins/alert_mixin';

export default {
  name: 'LandCourtOverview',
  mixins: [alert_mixin],
  data() {
    return {
      dashboard_loading: false,
      dashboard_error: '',
    };
  },
  async mounted() {
    await this.embed_superset_dashboard();
  },
  beforeUnmount() {
    this.clear_dashboard_container();
  },
  methods: {
    async embed_superset_dashboard() {
      this.dashboard_loading = true;
      this.dashboard_error = '';
      this.clear_dashboard_container();

      try {
        const dashboard_config = await fetch_land_court_superset_dashboard();
        const dashboard_id = dashboard_config.dashboard_id;
        const superset_domain = dashboard_config.superset_domain;
        const guest_token = dashboard_config.guest_token;

        if (!dashboard_id || !superset_domain || !guest_token) {
          throw new Error('Superset dashboard configuration is incomplete.');
        }

        await embedDashboard({
          id: dashboard_id,
          supersetDomain: superset_domain,
          mountPoint: this.$refs.superset_dashboard_mount,
          fetchGuestToken: () => Promise.resolve(guest_token),
          dashboardUiConfig: {
            hideTitle: true,
            hideChartControls: true,
            hideTab: true,
            filters: {
              expanded: false,
              visible: true,
            },
          },
        });

        this.size_superset_iframe();
      } catch (error) {
        const message = error?.response?.data?.message || error?.message || 'Failed to load Superset dashboard.';
        this.dashboard_error = message;
        this.show_error(message);
      } finally {
        this.dashboard_loading = false;
      }
    },
    clear_dashboard_container() {
      const mount_point = this.$refs.superset_dashboard_mount;
      if (mount_point) {
        mount_point.innerHTML = '';
      }
    },
    size_superset_iframe() {
      this.$nextTick(() => {
        const mount_point = this.$refs.superset_dashboard_mount;
        const iframe = mount_point?.querySelector('iframe');
        if (!iframe) {
          return;
        }

        iframe.setAttribute('title', 'Land Court Superset dashboard');
        iframe.style.width = '100%';
        iframe.style.height = '1600px';
        iframe.style.minHeight = 'calc(100vh - 8rem)';
        iframe.style.border = '0';
        iframe.style.display = 'block';
      });
    },
  },
};
